import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../images/logo.jpg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img src={logo} alt="ITLIT Logo" className="footer-logo" />
        <div className="footer-links">
          <a
            href="https://itlit.co.jp/company/overview/"
            target="_blank"
            rel="noopener noreferrer"
          >
            会社情報
          </a>

          <Link to="/privacy-policy">プライバシーポリシー</Link>
        </div>
      </div>
      <p className="footer-rights">
        © 2025 ITLIT Co., Ltd. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
